/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Systems_AdminInputs */

const en_common_systems_admin = /** @type {(inputs: Common_Systems_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const zh_common_systems_admin = /** @type {(inputs: Common_Systems_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理后台`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Common_Systems_AdminInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_systems_admin = /** @type {((inputs?: Common_Systems_AdminInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Systems_AdminInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_systems_admin(inputs)
	return zh_common_systems_admin(inputs)
});
export { common_systems_admin as "common.systems.admin" }